import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-join-modal',
    templateUrl: './join-modal.component.html',
    styleUrls: ['./join-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JoinModalComponent {

}
